// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"058d70a4","453":"3fb82d84","455":"8643467d","977":"9c8ad0ca"}[chunkId] + ".chunk.js";
};